import { render } from "./proposaldetailscheckdiy.vue?vue&type=template&id=9e662d68&scoped=true"
import script from "./proposaldetailscheckdiy.vue?vue&type=script&lang=js"
export * from "./proposaldetailscheckdiy.vue?vue&type=script&lang=js"

import "./proposaldetailscheckdiy.vue?vue&type=style&index=0&id=9e662d68&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e662d68"]])

export default __exports__